<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="form-restore col-xs-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
                <form v-on:submit.prevent="onSubmit">
                    <h1 class="title">Восстановить доступ</h1>

                    <div v-if="errorMessage" class="row">
                        <div class="form-group col-xs-12 col-md-12">
                            <div class="alert alert-danger">{{ errorMessage }}</div>
                        </div>
                    </div>

                    <div v-if="successMessage" class="row">
                        <div class="form-group col-xs-12 col-md-12">
                            <div class="alert alert-success">{{ successMessage }}</div>
                        </div>
                    </div>

                    <div v-if="!successMessage" class="row">
                        <div class="form-group col-xs-12 col-md-12">
                            <label for="email">Ваш email</label>
                            <input v-bind:class="{'is-invalid': $v.restore.email.$error}"
                                   v-model="restore.email"
                                   v-on:input="$v.restore.email.$touch"
                                   class="form-control form-control-lg"
                                   type="email"
                                   name="email"
                                   id="email"
                                   autofocus>
                        </div>

                        <button v-bind:disabled="loading"
                                v-bind:class="{'btn-loading': loading}"
                                type="submit"
                                class="btn btn-lg btn-danger submit">Восстановить</button>
                    </div>

                    <div class="row">
                        <div class="form-footer col-xs-12 col-md-12">
                            <hr>

                            <p><a href="/">Вернуться</a></p>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import { validationMixin } from "vuelidate";
    import { restoreValidationForm } from "./validations/restoreValidationForm";
    import { restoreApi } from "./api/restoreApi";

    export default {
        name: "Restore",
        mixins: [
            validationMixin,
        ],
        data: function() {
            return {
                successMessage: '',
                errorMessage: '',
                loading: false,
                restore: {
                    email: '',
                }
            };
        },
        methods: {
            onSubmit: function() {
                this.$v.$touch();

                if (this.loading) {
                    return;
                }

                this.errorMessage = '';
                this.successMessage = '';

                if (this.$v.$invalid) {
                    this.errorMessage = 'Заполните все обязательные поля';

                    return;
                }

                this.loading = true;

                restoreApi.doRestore(this.restore)
                    .then((response) => {
                        if (response.result === 'error') {
                            this.errorMessage = response.message;

                            return;
                        }

                        this.successMessage = response.message;
                    })
                    .catch((e) => {
                        this.errorMessage = e.message;
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
        },
        validations: {
            restore: restoreValidationForm
        }
    }
</script>

<style scoped>

</style>